const initialState = {
  resultsGuestDirectoryCategoryList: [],
  resultsGuestDirectoryCategory: {},
  resultsGuestDirectoryCategoryAdd: {},
  resultsGuestDirectoryCategoryPatch: {},
  resultsGuestDirectoryCategoryDelete: {},
}

const reducer = (state = initialState, action) => {
  const newState = { ...state }

  switch (action.type) {
    case "LIST_GUEST_DIRECTORY_CATEGORY_RESPONSE_GET":
      newState.resultsGuestDirectoryCategoryList = action.value
      break
    case "GUEST_DIRECTORY_CATEGORY_RESPONSE_GET":
      newState.resultsGuestDirectoryCategory = action.value
      break
    case "GUEST_DIRECTORY_CATEGORY_RESPONSE_ADD":
      newState.resultsGuestDirectoryCategoryAdd = action.value
      break
    case "GUEST_DIRECTORY_CATEGORY_RESPONSE_UPDATE":
      newState.resultsGuestDirectoryCategoryPatch = action.value
      break
    case "GUEST_DIRECTORY_CATEGORY_RESPONSE_DELETE":
      newState.resultsGuestDirectoryCategoryDelete = action.value
      break
    case "RESET_GUEST_DIRECTORY_CATEGORY_RESPONSES":
      newState.resultsGuestDirectoryCategoryAdd = {}
      newState.resultsGuestDirectoryCategoryPatch = {}
      newState.resultsGuestDirectoryCategoryDelete = {}
      break
    case "RESET_GUEST_DIRECTORY_CATEGORY_RESPONSE":
      newState.resultsGuestDirectoryCategoryList = []
      break
    default:
      break
  }
  return newState
}

export default reducer
